/**
 * Aligne les chaînes domaine / sous-domaine (dashboard, localStorage) sur les noms du catalogue exam,
 * pour que la sélection soit visible dans les modales et que revision_qcm reçoive les mêmes clés que Mongo.
 */

function norm(s) {
    return String(s || '')
        .trim()
        .replace(/\.$/, '')
        .toLowerCase();
}

/**
 * @param {string[]} domainNames
 * @param {{ name: string }[]} catalogDomains
 * @returns {string[]}
 */
export function alignDomainSelectionToCatalog(domainNames, catalogDomains) {
    const rows = catalogDomains || [];
    if (!Array.isArray(domainNames) || !rows.length) return domainNames || [];
    return domainNames.map((raw) => {
        const s = String(raw || '').trim();
        if (!s || s.toLowerCase() === 'all') return s;
        const byExact = rows.find((d) => String(d.name).trim() === s);
        if (byExact) return String(byExact.name).trim();
        const byCi = rows.find((d) => norm(d.name) === norm(s));
        if (byCi) return String(byCi.name).trim();
        return s;
    });
}

function subKey(row) {
    return String(row?.sub_domain || row?.task || '').trim();
}

/**
 * @param {string[]} taskNames
 * @param {object[]} catalogSubtasks
 * @returns {string[]}
 */
export function alignTaskSelectionToCatalog(taskNames, catalogSubtasks) {
    const rows = catalogSubtasks || [];
    if (!Array.isArray(taskNames) || !rows.length) return taskNames || [];
    return taskNames.map((raw) => {
        const s = String(raw || '').trim();
        if (!s) return s;
        const byExact = rows.find((t) => subKey(t) === s);
        if (byExact) return subKey(byExact);
        const byCi = rows.find((t) => norm(subKey(t)) === norm(s));
        if (byCi) return subKey(byCi);
        return s;
    });
}

/** Sélection modale domaine : même clé que le catalogue (trim + casse). */
export function domainSelectionIncludesName(domainSelection, catalogName) {
    const c = String(catalogName || '').trim();
    if (!c) return false;
    return (domainSelection || []).some((x) => norm(x) === norm(c) || String(x).trim() === c);
}

/** Sélection modale sous-domaine. */
export function taskSelectionIncludesName(taskSelection, catalogSubKey) {
    const c = String(catalogSubKey || '').trim();
    if (!c) return false;
    return (taskSelection || []).some((x) => norm(x) === norm(c) || String(x).trim() === c);
}
